import React, { useState, useEffect } from "react";
import Swal from "sweetalert2";
import { Modal, Button, Container, Row, Col } from "react-bootstrap";
import RepairServices from "../../../services/RepairServices";

function ApprovalOrRejectedModalSuperAdminModal({ show, item, handleClose, onSuccess }) {

  const [formValues, setFormValues] = useState({
    // INVENTORY ITEM
    invPartNo: "",
    invDescription: "",

    // REPAIR MASTER ITEM
    repairPartNo: "",
    repairDescription: "",
    repairUnit: "",

    // USER INPUTS
    qtyRequired: 0,

    // OTHERS
    requisitionNo: "",
    user: "",
    store: "",
    remark: "",
  });

  // ======================================================
  // LOAD DATA WHEN MODAL OPENS
  // ======================================================
  useEffect(() => {
    if (!item) return;

    try {
      const inv = item?.repairOrder?.inventory; // inventory item
      const master = item?.masterlist; // repair master item

      setFormValues({
        // INVENTORY DETAILS
        invPartNo: inv?.masterItem?.partNo || "",
        invDescription: inv?.masterItem?.description || "",

        // MASTER ITEM DETAILS
        repairPartNo: master?.partNo || "",
        repairDescription: master?.description || "",
        repairUnit: master?.unit?.name || "",

        // REQUIRED QTY
        qtyRequired: item?.qtyRequired || 0,

        // OTHER DETAILS
        requisitionNo: item?.repairOrder?.repairOrderNo || "",
        user: item?.user?.name || "",
        store: item?.store?.name || "",
        remark: item?.adminRemark || "",
      });

    } catch (err) {
      console.error("Error loading modal data:", err);
      Swal.fire("Error", "Unable to load item details", "error");
    }
  }, [item]);

  // ======================================================
  // HANDLE INPUT CHANGE
  // ======================================================
  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setFormValues((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // ======================================================
  // UPDATE REQUIRED QTY
  // ======================================================
  const handleEdit = async (event) => {
    event.preventDefault();

    if (!formValues.qtyRequired || formValues.qtyRequired <= 0) {
      return Swal.fire("Error", "Required Qty must be greater than 0", "error");
    }

    try {
      await RepairServices.updateItem(item._id, {
        qtyRequired: formValues.qtyRequired,
      });

      Swal.fire("Success", "Updated successfully!", "success");
      onSuccess();
      handleClose();
    } catch (error) {
      console.error("Error while updating required quantity:", error);
      Swal.fire("Error", "Unable to update. Please try again.", "error");
    }
  };

  // ======================================================
  // RENDER UI
  // ======================================================
  return (
    <Modal show={show} onHide={handleClose} size="lg">
      <form onSubmit={handleEdit}>
        <Modal.Header>
          <Modal.Title>Edit Requisition</Modal.Title>
          <Button variant="close" onClick={handleClose}></Button>
        </Modal.Header>

        <Modal.Body>
          <Container>

            {/* Inventory Details */}
            <Row>
              <Col md="6">
                <label>Inventory Part No</label>
                <input className="form-control form-control-sm" value={formValues.invPartNo} readOnly />
              </Col>

              <Col md="6">
                <label>Inventory Description</label>
                <textarea className="form-control form-control-sm" rows="1" value={formValues.invDescription} readOnly />
              </Col>
            </Row>

            {/* Repair Master Details */}
            <Row className="mt-3">
              <Col md="6">
                <label>Repair Master Part No</label>
                <input className="form-control form-control-sm" value={formValues.repairPartNo} readOnly />
              </Col>

              <Col md="6">
                <label>Repair Master Description</label>
                <textarea className="form-control form-control-sm" rows="1" value={formValues.repairDescription} readOnly />
              </Col>
            </Row>

            {/* Unit (only repair item) + Required Qty */}
            <Row className="mt-3">
              <Col md="4">
                <label>Unit</label>
                <input className="form-control form-control-sm" value={formValues.repairUnit} readOnly />
              </Col>

              <Col md="4">
                <label>Requested Qty</label>
                <input
                  type="number"
                  name="qtyRequired"
                  className="form-control form-control-sm"
                  value={formValues.qtyRequired}
                  onChange={handleInputChange}
                />
              </Col>
            </Row>

            {/* Footer Info */}
            <Row className="mt-3">
              <Col md="6">
                <label>Store</label>
                <input className="form-control form-control-sm" value={formValues.store} readOnly />
              </Col>

              <Col md="6">
                <label>Repair Order No</label>
                <input className="form-control form-control-sm" value={formValues.requisitionNo} readOnly />
              </Col>
            </Row>

            <Row className="mt-3">
              <Col md="12">
                <label>Admin Remark</label>
                <input className="form-control form-control-sm" value={formValues.remark} readOnly />
              </Col>
            </Row>

          </Container>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="primary" type="submit">
            Update Required Qty
          </Button>
        </Modal.Footer>
      </form>
    </Modal>
  );
}

export default ApprovalOrRejectedModalSuperAdminModal;
